import { useIntl } from "react-intl";
import { useGetQueuesSize } from "src/app/hooks";

const SizeOfQueuesContainer = () => {
    const { formatMessage } = useIntl();
    const { queueSize } = useGetQueuesSize();

    if (!queueSize) return <></>;
    const keys = Object.keys(queueSize);
    return (
        <div className="sizeOfQueuesContainerWrapper">
            {keys ? (
                <div className="queuesInfor">
                    {keys.map((key, index) => (
                        <p className="form-label" key={index}>
                            <li>
                                {formatMessage({ id: `queue.${key}.total` })} :{" "}
                                <span>{queueSize[key as keyof typeof queueSize]}</span>
                            </li>
                        </p>
                    ))}
                </div>
            ) : (
                ""
            )}
        </div>
    );
};

export default SizeOfQueuesContainer;
